// Auto-detect host: production uses IP/hostname, dev uses localhost
// Override with VITE_API_URL env var when needed (e.g. mobile emulator)
const API_HOST =
  typeof window !== 'undefined' && window.location?.hostname
    ? window.location.hostname
    : 'localhost';

// An empty VITE_API_URL is a deliberate setting, not an absent one: it means
// "use relative paths" so calls go through whatever proxy is serving the app
// (nginx /api/ in the prod image). `||` collapsed that into the :8004 guess,
// which no prod deployment listens on. Only an undefined value falls back.
const configuredApiUrl = import.meta.env.VITE_API_URL;

export const BASE_URL =
  configuredApiUrl === undefined ? `http://${API_HOST}:8004` : configuredApiUrl;

export const API_URLs = {
  // Auth
  register: `${BASE_URL}/api/v1/users/register`,
  login: `${BASE_URL}/api/v1/users/login`,
  refreshToken: `${BASE_URL}/api/v1/users/refresh-token`,
  logout: `${BASE_URL}/api/v1/users/logout`,
  currentUser: `${BASE_URL}/api/v1/users/current-user`,
  changePassword: `${BASE_URL}/api/v1/users/change-password`,
  forgotPassword: `${BASE_URL}/api/v1/users/forgot-password`,
  verifyOtp: `${BASE_URL}/api/v1/users/verify-otp`,
  users: `${BASE_URL}/api/v1/users`,

  // Permissions
  getCurrentUserPermissions: `${BASE_URL}/api/v1/users/get-user-permissions`,

  // Health
  healthcheck: `${BASE_URL}/api/v1/healthcheck`,

  // Fulfillment cockpit. Paths mirror the original Supply_Planner API so the
  // recorded golden fixtures stay a valid contract check for the backend.
  fulfillmentSource: `${BASE_URL}/api/v1/fulfillment/source`,
  fulfillmentSummary: `${BASE_URL}/api/v1/fulfillment/summary`,
  fulfillmentOrders: `${BASE_URL}/api/v1/fulfillment/orders`,
  fulfillmentAtp: `${BASE_URL}/api/v1/fulfillment/atp`,
  fulfillmentAtpHorizons: `${BASE_URL}/api/v1/fulfillment/atp-horizons`,
  fulfillmentAtpDetail: `${BASE_URL}/api/v1/fulfillment/atp-detail`,
  fulfillmentExecSummary: `${BASE_URL}/api/v1/fulfillment/exec-summary`,
  fulfillmentExecNarrative: `${BASE_URL}/api/v1/fulfillment/exec-narrative`,
  fulfillmentDeliverable: `${BASE_URL}/api/v1/fulfillment/deliverable`,
  fulfillmentBacklogByFiscalMonth: `${BASE_URL}/api/v1/fulfillment/backlog-by-fiscal-month`,
  fulfillmentPlantView: `${BASE_URL}/api/v1/fulfillment/plant-view`,
  fulfillmentPlantChart: `${BASE_URL}/api/v1/fulfillment/plant-chart`,
  fulfillmentReservations: `${BASE_URL}/api/v1/fulfillment/reservations`,
  fulfillmentTracking: `${BASE_URL}/api/v1/fulfillment/tracking`,
  fulfillmentExportExcel: `${BASE_URL}/api/v1/fulfillment/export/fulfillment`,
  fulfillmentExportHtml: `${BASE_URL}/api/v1/fulfillment/export/fulfillment_html`,
  fulfillmentUploads: `${BASE_URL}/api/v1/fulfillment/uploads`,
  // Row actions — cockpit-side annotations, not exports of the source data.
  // Mirrors the backend's POST /orders/:orderNumber/{escalate,snooze} and
  // DELETE /orders/:orderNumber/escalate. Built here (rather than assembled
  // inline in the component) so the orderNumber path segment has exactly one
  // home.
  orderEscalate: (orderNumber) =>
    `${BASE_URL}/api/v1/fulfillment/orders/${encodeURIComponent(orderNumber)}/escalate`,
  orderSnooze: (orderNumber) =>
    `${BASE_URL}/api/v1/fulfillment/orders/${encodeURIComponent(orderNumber)}/snooze`,
  // Reel Inspector — every physical reel behind one cable material. A function
  // for the same reason as the two above: the material is a path segment, and
  // materials can carry characters that need escaping.
  fulfillmentReels: (material) =>
    `${BASE_URL}/api/v1/fulfillment/reels/${encodeURIComponent(material)}`,
};
